import { render } from "./InsightPreferences.vue?vue&type=template&id=371bd3d9"
import script from "./InsightPreferences.vue?vue&type=script&lang=js"
export * from "./InsightPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/user_profile/InsightPreferences.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "371bd3d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('371bd3d9', __exports__)) {
    api.reload('371bd3d9', __exports__)
  }
  
  module.hot.accept("./InsightPreferences.vue?vue&type=template&id=371bd3d9", () => {
    api.rerender('371bd3d9', render)
  })

}


export default __exports__